/* Alternate-template enhancements; all purchases go through Dawn's native product form. */
if (!customElements.get('cb-delivery-status')) {
  customElements.define('cb-delivery-status', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const source = data.html.querySelector('cb-delivery-status');
        if (source) this.innerHTML = source.innerHTML;
      });
      this.pending = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        if (this.closest('product-info')?.contains(data.event.target)) {
          this.querySelectorAll('.custom-dc-badge').forEach(node => node.hidden = true);
        }
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); this.pending?.(); }
  });
}
if (!customElements.get('cb-sticky-atc')) {
  customElements.define('cb-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.nativeButton = this.info?.querySelector('[id^="ProductSubmitButton-"]');
      if (!this.nativeButton) return;
      this.hidden = false;
      this.clickHandler = event => {
        if (event.target.closest('[data-sticky-add]') && !this.nativeButton.disabled && this.nativeButton.getAttribute('aria-disabled') !== 'true') this.nativeButton.click();
      };
      this.changeHandler = event => {
        if (!event.target.matches('[data-sticky-option]')) return;
        const target = [...this.info.querySelectorAll('variant-selects [data-option-value-id]')].find(node => node.dataset.optionValueId === event.target.value);
        if (!target) return;
        if (target.tagName === 'OPTION') { target.parentElement.value = target.value; target.parentElement.dispatchEvent(new Event('change', { bubbles: true })); }
        else { target.checked = true; target.dispatchEvent(new Event('change', { bubbles: true })); }
      };
      this.addEventListener('click', this.clickHandler);
      this.addEventListener('change', this.changeHandler);
      this.sync = () => {
        const button = this.querySelector('[data-sticky-add]');
        if (!button) return;
        button.disabled = this.nativeButton.disabled || this.nativeButton.getAttribute('aria-disabled') === 'true';
        button.textContent = this.nativeButton.querySelector('span')?.textContent.trim() || this.nativeButton.textContent.trim();
      };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.nativeButton, { attributes: true, childList: true, subtree: true, characterData: true });
      this.updatePosition = () => {
        if (this.positionFrame) return;
        this.positionFrame = requestAnimationFrame(() => {
          this.positionFrame = null;
          this.classList.toggle('is-visible', this.nativeButton.getBoundingClientRect().bottom < 0);
        });
      };
      window.addEventListener('scroll', this.updatePosition, { passive: true });
      window.addEventListener('resize', this.updatePosition);
      this.intersection = new IntersectionObserver(this.updatePosition);
      this.updatePosition();
      this.intersection.observe(this.nativeButton);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const source = data.html.querySelector('cb-sticky-atc');
        if (source) this.innerHTML = source.innerHTML;
        this.sync();
      });
      this.sync();
    }
    disconnectedCallback() {
      this.unsubscribe?.(); this.observer?.disconnect(); this.intersection?.disconnect();
      window.removeEventListener('scroll', this.updatePosition);
      window.removeEventListener('resize', this.updatePosition);
      cancelAnimationFrame(this.positionFrame);
      this.removeEventListener('click', this.clickHandler); this.removeEventListener('change', this.changeHandler);
    }
  });
}
